import { observable, action, computed } from "mobx";
import { Dictionary, entities } from "sbtech-sports-data-api-client";

/**
* Selection defines model for selection object information
*
* @typedef Selection
* @type {Object}
* @property {id} BranchId identifier
* @property {title} Title of the Selection
* @property {odds} Odds of the Selection
* @property {points} points type number
*/

export enum OddStyles {
    decimal = "decimal",
    american = "american",
    fractional = "fractional",
    indo = "indo",
    malay = "malay",
    hk = "hk"
}

type SelectionSideByOutcomeFunc = {
    (selection: Selection) : entities.SelectionSide
}

const SelectionSideByOutcomeType = {
    [entities.OutcomeType.Home]: (s) => s.isSwapped ? entities.SelectionSide.Away : entities.SelectionSide.Home,
    [entities.OutcomeType.Away]: (s) => s.isSwapped ? entities.SelectionSide.Home : entities.SelectionSide.Away,
    [entities.OutcomeType.Over]: (s) => entities.SelectionSide.Home,
    [entities.OutcomeType.Under]: (s) => entities.SelectionSide.Away,
    [entities.OutcomeType.Draw]: (s) => entities.SelectionSide.Draw,
    [entities.OutcomeType.Tie]: (s) => entities.SelectionSide.Draw,
} as Dictionary<SelectionSideByOutcomeFunc>;

export type SelectionTypeObj = {
    id: string,
    title: string,
    points: number,
    odds: string,
    lineGroupId: string,
    outcomeType: string, // corresponds to rowTypeId from the legacy
    displayOdds: Dictionary<string>,
    isDisabled: boolean,
    isSelected: boolean,
    isSwapped: boolean,
    sbtechId: string,
};

export class Selection {
    id: string;

    sbtechId: string;

    title: string;
    @observable points: number;
    @observable displayOdds: Dictionary<string>;
    @observable odds: string;
    lineGroupId: string;
    outcomeType: string;
    @observable isDisabled: boolean;
    @observable isSelected: boolean;
    isSwapped: boolean;

    constructor(selectionData: SelectionTypeObj) {
        this.id = selectionData.id;
        this.title = selectionData.title;
        this.points = selectionData.points;
        this.odds = selectionData.odds;
        this.lineGroupId = selectionData.lineGroupId;
        this.outcomeType = selectionData.outcomeType;
        this.displayOdds = selectionData.displayOdds;
        this.isDisabled = selectionData.isDisabled;
        this.isSelected = selectionData.isSelected;
        this.isSwapped = selectionData.isSwapped;
        this.sbtechId = selectionData.sbtechId;
    }

    @action.bound
    update(selection: Selection): void {
        this.points = selection.points;
        this.odds = selection.odds;
        this.isDisabled = selection.isDisabled;
    }

    @action.bound
    updateIsSelected(value: boolean): void {
        this.isSelected = value;
    }

    @action.bound
    updateIsDisabled(value: boolean): void {
        this.isDisabled = value;
    }

    @action.bound
    updateOdds(odds: string): void {
        this.odds = odds;
    }

    @computed
    get displayHandicapPoints(): string {
        if (this.points > 0) {
            return `+${this.points}`;
        } else {
            return this.points.toString();
        }
    }

    /* istanbul ignore next */
    getSide(): number {
        return SelectionSideByOutcomeType[this.outcomeType] && SelectionSideByOutcomeType[this.outcomeType](this);
    }
}